<template>
  <div class="convert-wrap">
    <div class="convert-content">
      <!-- 左侧菜单 -->
      <div class="convert-left">
        <div class="convert-list-wrap">
          <div class="convert-left-line"></div>
          <div class="convert-left-title">PDF转换</div>
          <div
            :class="['convert-left-list', convertType.id === item.id ? 'list_active' : '']"
            v-for="item in menuList.slice(0, 4)"
            :key="item.id"
            @click="listClick(item)"
          >
            <img :src="item.list_icon" alt="">
            {{ item.name }}
          </div>
        </div>
        <div class="convert-list-wrap">
          <div class="convert-left-line"></div>
          <div class="convert-left-title">文档转PDF</div>
          <div
            :class="['convert-left-list', convertType.id === item.id ? 'list_active' : '']"
            v-for="item in menuList.slice(4, 10)"
            :key="item.id"
            @click="listClick(item)"
          >
            <img :src="item.list_icon" alt="">
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 右侧转换区域 -->
      <div class="convert-right">
        <!-- 标题 -->
        <div class="convert-right-title">
          <div class="convert-right-title-left">
            <h3 class="convert-right-title-left-name">{{ convertType.name }}</h3>
            <span class="convert-right-title-left-tips">文件过大，页数过多时，转换时间较长，可过后访问本站，查看转换记录（仅保留30天）</span>
          </div>
          <div class="convert-right-title-right">
            <!-- 转换记录按钮 -->
            <div
              class="convert-right-title-btn"
              v-if="isLogin"
              @click="toHistory"
            >
              转换记录
            </div>
            <!-- 添加文件按钮 -->
            <el-upload
              v-if="upFlag === 2"
              ref="upload"
              name="files"
              :action="action"
              :file-list="fileList"
              :data="uploadData()"
              :headers="headers"
              :show-file-list="false"
              :accept="accept"
              :before-upload="beforeUpload1"
              :on-progress="onProgress"
              :on-success="onSuccess"
              :on-error="onError1"
            >
              <div class="convert-right-title-btn btn-file">添加文件</div>
            </el-upload>
          </div>
        </div>
        <!-- 上传前 -->
        <div class="convert-update-wrap" v-if="upFlag === 1">
          <div class="convert-update">
            <div class="convert-update-icon">
              <img :src="convertType.pic" alt="" />
            </div>
            <el-upload
              name="files"
              :action="action"
              :file-list="fileList"
              :data="uploadData()"
              :headers="headers"
              :show-file-list="false"
              :accept="accept"
              :before-upload="beforeUpload"
              :on-progress="onProgress"
              :on-success="onSuccess"
              :on-error="onError"
            >
              <div class="convert-update-btn">
                <i class="el-icon-plus"></i>
                点击上传
              </div>
            </el-upload>
            <div class="convert-update-tips">最大支持50MB文件</div>
          </div>
        </div>
        <!-- 上传中 -->
        <div class="convert-update-wait" v-else-if="upFlag === 0">
          <div class="wait-icon">
            <img src="../assets/img/home/upload/wait.png" alt="" />
          </div>
          <div class="wait-desc">正在上传文件...</div>
        </div>
        <!-- 上传失败 -->
        <div class="convert-update-error" v-else-if="upFlag === -1">
          <div class="wait-icon">
            <img src="../assets/img/home/upload/error.png" alt="" />
          </div>
          <div class="wait-desc err">上传失败</div>
          <!-- <div class="big-btn" @click="uploadAgain">重新上传</div> -->
          <el-upload
            name="files"
            :action="action"
            :file-list="fileList"
            :data="uploadData()"
            :headers="headers"
            :show-file-list="false"
            :accept="accept"
            :before-upload="beforeUpload"
            :on-progress="onProgress"
            :on-success="onSuccess"
            :on-error="onError"
          >
            <div class="big-btn">
              重新上传
            </div>
          </el-upload>
        </div>
        <!-- 文件过大 -->
        <div class="convert-update-big big" v-else-if="upFlag === -2">
          <div class="big-left">
            <img style="height: 100px" src="../assets/img/home/upload/big.png" alt="" />
          </div>
          <div class="big-right">
            <div class="big-title">上传文件过大，超出在线转换限制</div>
            <div class="big-desc">
              您刚刚选择的文件已超过最大允许文件大小50M，暂未完成添加。<br>
              如果您需要对50M以上文件进行操作，您可以点击下方按钮，下载客户端。
            </div>
            <a href="https://cdn-office.lanshan.com/package/tui/downloadtool/pdf/PDFDownloaderInstall_1_000000_lanshan.exe" class="big-btn">下载客户端</a>
          </div>
        </div>
        <!-- 开通会员 -->
        <div class="convert-update-vip big" v-else-if="upFlag === -3">
          <div class="big-left">
            <img style="height: 100px" src="../assets/img/home/upload/big.png" alt="" />
          </div>
          <div class="big-right">
            <div class="big-title">上传文件过大，超出非会员用户限制</div>
            <div class="big-desc">
              您刚刚选择的文件已超过最大允许文件大小10M，暂未完成添加。<br>
              如果您需要对10M以上文件进行操作，您可以加入 蓝山PDF会员 享受无限制服务。
            </div>
            <div class="big-btn-desc-wrap">
              <el-upload
                name="files"
                :action="action"
                :file-list="fileList"
                :data="uploadData()"
                :headers="headers"
                :show-file-list="false"
                :accept="accept"
                :before-upload="beforeUpload"
                :on-progress="onProgress"
                :on-success="onSuccess"
                :on-error="onError"
              >
                <div class="big-btn bit-btn-v">
                  重新上传
                </div>
              </el-upload>
              <span class="big-btn-desc" @click="openVip"> >>>了解会员权益</span>
            </div>
          </div>
        </div>
        <!-- 转换列表 -->
        <div class="convert-update-list" v-else-if="upFlag === 2">
          <div class="convert-update-list-title">
            <div class="t1">文件名</div>
            <div class="t2">大小</div>
            <div class="t3">操作</div>
          </div>
          <div class="convert-update-list-item-wrap">
            <div class="convert-update-list-item" v-for="(item, index) in fileList" :key="index">
              <!-- 文件名 -->
              <div class="i1">
                <div class="i-icon">
                  <img :src="convertType.c_icon" alt="" />
                </div>
                <div class="i-name">{{ item.raw.name }}</div>
              </div>
              <!-- 文件大小 -->
              <div class="i2">{{ item.raw.sizes }}</div>
              <!-- 文件上传&转换状态 -->
              <div class="i3">
                <div class="i-status" v-show="item.raw.textType === 0">等待转换</div>
                <div class="i-status" v-show="item.raw.textType === 1">转换完成</div>
                <div class="i-status i-status-err" v-show="item.raw.textType === 2">转换失败</div>
                <div class="i-status" v-show="item.raw.textType === 3">正在转换</div>
                <div class="i-status" v-show="item.raw.textType === 8">正在上传</div>
                <div class="i-status i-status-err" v-show="item.raw.textType === -8">上传失败</div>
                <!-- 上传进度条 -->
                <div class="i-progress" v-show="item.raw.handleType === 0 && item.raw.preFlag === 1">
                  <el-progress :show-text="false" :percentage="item.percentage"></el-progress>
                </div>
                <!-- 转换进度条 -->
                <div class="i-progress" v-show="item.raw.handleType === 0 && item.raw.preFlag === 2">
                  <el-progress :show-text="false" :percentage="item.percentage"></el-progress>
                </div>
                <!-- 转换结果 -->
                <div class="i-download-f" v-show="item.raw.handleType === 1" @click="downloadFile(item)">下载文件</div>
                <a
                  class="i-download-c"
                  v-show="item.raw.handleType === 2"
                  href="https://cdn-office.lanshan.com/package/tui/downloadtool/pdf/PDFDownloaderInstall_1_000000_lanshan.exe"
                >
                  下载客户端
                </a>
                <!-- <div class="i-upload-again" v-show="item.raw.handleType === -1">重新上传</div> -->
                <!-- <div v-show="item.raw.handleType === -1"></div> -->
                <el-upload
                  v-show="item.raw.handleType === -1"
                  ref="upload"
                  name="files"
                  :action="action"
                  :file-list="fileList"
                  :data="uploadData()"
                  :headers="headers"
                  :show-file-list="false"
                  :accept="accept"
                  :before-upload="beforeUpload1"
                  :on-progress="onProgress"
                  :on-success="onSuccess"
                  :on-error="onError1"
                >
                  <div class="i-upload-again">重新上传</div>
                </el-upload>
              </div>
            </div>
          </div>
        </div>
        <!-- 提示 -->
        <div class="convert-tip">
          <div class="convert-tip-top">注意：如果PDF有密码保护，请先去除加密保护再上传文件</div>
          <div class="convert-tip-bottom">
            <span class="convert-tip-bottom-text">非会员用户转换大小仅限于10M以内文件，如需转换更大文件、转换更多格式文件，请</span>
            <div class="convert-tip-bottom-btn open-vip-btn" @click="openVip">开通会员</div>
            <span class="convert-tip-bottom-text">或</span>
            <a href="https://cdn-office.lanshan.com/package/tui/downloadtool/pdf/PDFDownloaderInstall_1_000000_lanshan.exe" class="convert-tip-bottom-btn download-client">下载客户端</a>
          </div>
        </div>
      </div>
      <!-- tost提示 -->
      <transition name="el-fade-in-linear">
        <div class="tost" v-show="showTost">{{ tostText }}</div>
      </transition>
    </div>
  </div>
</template>

<script>
import { menuList } from "@/utils/menu";
import { fileTypes } from "./const";
import { transFiles, convertResult } from "@/apis/trans";
import { downloadOne } from '@/apis/trans';
import { readFile } from '@/utils/readfile';
import AES from '@/utils/ase.js';
import { commonParams } from "@/utils/publicParam";
export default {
  props: {
    convertType: {
      type: Object,
      default() {
        return {
          id: 1,
          name: "PDF转Word", // 名称
          pic: require("@/assets/img/trans/t/pdf-word.png"), // 转换图标
          list_icon: require("@/assets/img/home/list/i1.png"), // 转换区域右侧列表图标
          c_icon: require("@/assets/img/home/upload/i-pdf.png"), // 上传&转换文件名前面的icon
          href: "/pdf-to-word", // 页面路由
          type: 4, // 转换类型，转换接口传给后端
          last: "doc", // 转换结果的文件后缀
          download: 1, // 下载类型，1单文件下载，2压缩包下载
          isHot: false // 是否是当前热门
        }
      }
    },
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuList,
      action: "",
      accept: "",
      fileList: [],
      headers: {
        token: window.localStorage.getItem("token")
      },
      // 上传状态 1上传文件初始状态 0上传中 -1上传失败 -2过大下载客户端 -3过大充值会员  2上传成功列表
      upFlag: 1,
      // isLogin: this.$parent.$refs.headers.isLogin,
      tostText: "",
      showTost: false,
      changeNum: 0
      // convertTimer: null,
      // statusTimer: null
    }
  },
  created() {
    const path = this.$route.name;

    this.accept = fileTypes[path]["accept"];
    this.action = `${process.env.VUE_APP_API_CONVERT}${fileTypes[path]["action"]}`;
  },
  methods: {
    // 上传data
    uploadData() {
      return { ...commonParams }
    //   const path = this.$route.name;
    //   return { type: fileTypes[path]["type"] };
    },
    // 左侧菜单点击
    listClick(item) {
      this.$router.push(item.href);
    },
    // 第一个文件上传前，控制上传状态
    beforeUpload(file) {
      const files = file;

      files.preFlag = 1;
      files.textType = 8; // 上传&转换状态
      files.handleType = 0; // 显示进度条还是按钮
      files.sizes = this.changeSize(files.size); // 文件大小转换
      file.max = false;
      // 会员用户：上传不超过50M，如果超过50M，提示下载客户端，不超过50M正常上传
      // 非会员用户：上传不超过10M，如果超过10M，提示充值会员，不超过10M正常上传
      const vip = localStorage.getItem("isVip");
      const isSize = file.size / 1024 / 1024;

      if (vip === "true") {
        if (isSize > 50) {
          this.upFlag = -2;
          return false;
        } else {
          this.upFlag = 0;
        }
      } else {
        if (isSize > 50) {
          this.upFlag = -2;
          return false;
        } else if (isSize >= 10) {
          this.upFlag = -3;
          return false;
        } else {
          this.upFlag = 0;
        }
      }
    },
    // 第N个文件上传前，控制上传状态
    beforeUpload1(file) {
      const files = file;

      files.preFlag = 1;
      files.textType = 8; // 上传&转换状态
      files.handleType = 0; // 显示进度条还是按钮
      files.sizes = this.changeSize(files.size); // 文件大小转换
      file.max = false;
      // 会员用户：上传不超过50M，如果超过50M，提示下载客户端，不超过50M正常上传
      // 非会员用户：上传不超过10M，如果超过10M，提示充值会员，不超过10M正常上传
      const vip = localStorage.getItem("isVip");
      const isSize = file.size / 1024 / 1024;

      if (vip === "true") {
        if (isSize > 50) {
          this.showTost = true;
          this.tostText = "上传文件超过50M，超出在线转换限制";
          const tostTime = setTimeout(() => {
            this.showTost = false;
            clearTimeout(tostTime);
          }, 3000);
          return false;
        }
      } else {
        if (isSize >= 10 && isSize < 50) {
          this.showTost = true;
          this.tostText = "上传文件过大，超出免费体验限制，成为会员取消限制";
          const tostTime = setTimeout(() => {
            this.showTost = false;
            clearTimeout(tostTime);
          }, 3000);
          return false;
        } else if (isSize > 50) {
          this.showTost = true;
          this.tostText = "上传文件超过50M，超出在线转换限制";
          const tostTime = setTimeout(() => {
            this.showTost = false;
            clearTimeout(tostTime);
          }, 3000);
          return false;
        }
      }
      const arr = [];

      this.fileList.forEach(item => {
        if (!item.max) {
          arr.push(item);
        }
      });
      if (arr.length > 4) {
        this.showTost = true;
        this.tostText = "每次最多同时转换5个文件，请耐心等待";
        const tostTime = setTimeout(() => {
          this.showTost = false;
          clearTimeout(tostTime);
        }, 3000);
        return false;
      }
    },
    // 上传中
    onProgress(event, file, fileList) {
      // this.upFlag = 2;
      this.fileList = fileList;
      const files = file.raw;

      files.textType = 8;
      files.handleType = 0;
    },
    // 上传成功
    onSuccess(response, file, fileList) {
      if (window._czc) {
        window._czc.push(['_trackEvent', '蓝山在线文档转换', `${this.convertType.name}`, '上传成功']);
      }
      const files = file.raw;

      if (response.code === 0) {
        this.upFlag = 2;
        files.textType = 3;
        files.handleType = 0;
        files.preFlag = 2;
        file.percentage = 0;
        const obj = { name: response.data.fileName, convertType: this.convertType.type, ...commonParams };
        const rObj = AES.encrypt(JSON.stringify(obj))

        transFiles(rObj)
          .then(response => {
            const res = JSON.parse(AES.decrypt(response));

            if (res.code === 0) {
              if (res.data.status === 2) {
                files.textType = 2;
                files.handleType = 2;
                this.changeNum = this.changeNum - 1;
              } else if (res.data.status === 3) {
                // 正在转换
                files.pnum = 0;
                files.convertTimer = setInterval(() => {
                  files.pnum = files.pnum + 1;
                  file.percentage = files.pnum;
                  if (files.pnum === 80) {
                    clearInterval(files.convertTimer);
                  }
                }, 100);

                files.textType = 3;
                files.handleType = 0;
                const resultObj = { name: res.data.fileName, ...commonParams };
                const reqObj = AES.encrypt(JSON.stringify(resultObj));

                // 轮询查询结果
                files.statusTimer = setInterval(() => {
                  convertResult(reqObj).then(response => {
                    const res = JSON.parse(AES.decrypt(response));

                    if (res.code === 0) {
                      if (res.data.status === 1) {
                        // 成功
                        if (window._czc) {
                          window._czc.push(['_trackEvent', '蓝山在线文档转换', `${this.convertType.name}`, '转换成功']);
                        }
                        files.textType = 1;
                        files.handleType = 1;
                        file.percentage = 100;
                        file.max = true;
                        clearInterval(files.statusTimer);
                        this.changeNum = this.changeNum - 1;
                      } else if (res.data.status === 2) {
                        // 失败
                        if (window._czc) {
                          window._czc.push(['_trackEvent', '蓝山在线文档转换', `${this.convertType.name}`, '转换失败']);
                        }
                        files.textType = 2;
                        files.handleType = 2;
                        file.percentage = 100;
                        file.max = true;
                        clearInterval(files.statusTimer);
                        this.changeNum = this.changeNum - 1;
                      } else if (res.data.status === 3) {
                        return;
                      }
                    }
                  }).catch(err => {
                    console.log(err);
                  });
                }, 2000);
              }
            } else {
              this.showTost = true;
              this.tostText = res.message;
              const tostTime = setTimeout(() => {
                this.showTost = false;
                clearTimeout(tostTime);
              }, 3000);
            }
          })
          .catch(err => {
            console.log(err);
            files.textType = -2;
            this.changeNum = this.changeNum - 1;
          })
      } else {
        if (fileList.length > 1) {
          files.textType = -8;
          files.handleType = -1;
          file.percentage = 0;
        } else {
          this.upFlag = -1;
          this.fileList = [];
        }
      }
    },
    // 第一个文件，上传失败
    onError() {
      if (window._czc) {
        window._czc.push(['_trackEvent', '蓝山在线文档转换', `${this.convertType.name}`, '上传失败']);
      }
      this.upFlag = -1;
      this.fileList = [];
    },
    // 第N个文件，上传失败
    onError1(err, file, fileList) {
      console.log(err, fileList);
      if (window._czc) {
        window._czc.push(['_trackEvent', '蓝山在线文档转换', `${this.convertType.name}`, '上传失败']);
      }
      const files = file.raw;

      files.textType = -8;
      files.handleType = -1;
    },
    // 文件大小换算
    changeSize(fileByte) {
      const fileSizeByte = fileByte
      let fileSizeMsg = ''

      if (fileSizeByte < 1048576) fileSizeMsg = (fileSizeByte / 1024).toFixed(1) + 'KB'
      else if (fileSizeByte === 1048576) fileSizeMsg = '1MB'
      else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) fileSizeMsg = (fileSizeByte / (1024 * 1024)).toFixed(1) + 'MB'
      else if (fileSizeByte > 1048576 && fileSizeByte === 1073741824) fileSizeMsg = '1GB'
      else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) fileSizeMsg = (fileSizeByte / (1024 * 1024 * 1024)).toFixed(1) + 'GB'
      else fileSizeMsg = '文件超过1TB'
      return fileSizeMsg
    },
    // 上传失败-重新上传
    // uploadAgain() {
    //   this.upFlag = 1;
    //   this.fileList = [];
    // },
    // 下载文件
    downloadFile(item, index) {
      if (window._czc) {
        window._czc.push(['_trackEvent', '蓝山在线文档转换', `${this.convertType.name}`, '下载按钮点击']);
      }
      if (!localStorage.getItem('token')) {
        this.$parent.$refs.headers.OpenDialog()
      }
      let str = item.name;
      const i = str.lastIndexOf(".");

      str = `${str.substring(0, i + 1)}${this.convertType.last}`;
      // 下载图片，压缩
      this.donwloadFileCallback(item.response.data.fileName, str);
    },
    // 下载文件回调
    donwloadFileCallback(fileName, name) {
      const loading = this.$loading({
        lock: true,
        text: '正在下载',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      downloadOne({ filename: fileName }).then(res => {
        readFile(res, name).then(res => {
          loading.close();
        }).catch(err => {
          loading.close();
          if (err.code === 103) {
            this.$confirm('下载大于2M文件需要先购买会员', '提示', {
              confirmButtonText: '去购买',
              cancelButtonText: '我在想想',
              type: 'warning'
            }).then(() => {
              this.$router.push('product')
            })
          } else if (err.code === 102) {
            this.$confirm('您没有下载次数，充值会员可继续下载', '提示', {
              confirmButtonText: '去购买',
              cancelButtonText: '我在想想',
              type: 'warning'
            }).then(() => {
              this.openVip();
            })
          }
        })
      }).catch(err => {
        console.log(err);
        loading.close();
      })
    },
    // 打开开通会员页
    openVip() {
      const routeUrl = this.$router.resolve({
        path: '/product'
      });

      window.open(routeUrl.href, '_blank');
    },
    // 打开转换记录
    toHistory() {
      const routeUrl = this.$router.resolve({
        path: '/history'
      });

      window.open(routeUrl.href, '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/convert.scss";
</style>
